import React, { FC, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import styled from 'styled-components';
import { NotificationStatus } from 'api/notifications';
import { Content } from 'components/organisms/notifications/list/content';
import { CurrentUserContext } from 'contexts';
import { RootState } from 'data';
import { useUser } from 'hooks/use-user';
import { putAll, UsersStore } from 'stores/users';
import { content, other, users } from './content';

const Wrapper = styled.div`
  margin: 0 auto;
  width: 768px;
`;

export const Notifications: FC = () => {
  const title = 'Notifications demo';
  const [initialized, setInitialized] = useState(false);
  const usersStore = useSelector((root: RootState) => root.users);
  const userInfo = useUser();
  const loaded = UsersStore.loaded(usersStore);
  const dispatch = useDispatch();

  useEffect(() => {
    if (initialized || !loaded) {
      return;
    }
    dispatch(putAll(users));
    setInitialized(true);
  }, [dispatch, loaded, initialized, setInitialized]);

  useEffect(() => {
    return () => {
      window.setTimeout(() => window.location.reload(), 200);
    };
  }, [dispatch]);

  return (
    <CurrentUserContext.Provider value={{ ...userInfo, user: other }}>
      <h3>{title}</h3>
      <Wrapper>
        <Content status={NotificationStatus.New} content={content} />
      </Wrapper>
    </CurrentUserContext.Provider>
  );
};
